import { Component, inject, Input, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService, DismissedPopupKeywords, LinksService } from '@isophi/core-legacy';
import { map } from 'rxjs';

import { RouterLinkFactory } from '../../../core/router/router-link.factory';
import { KindergartenService } from '../../../core/services/kindergarten.service';
import { PopupService } from '../../../core/services/popup.service';

@Component({
    selector: 'app-innitial-popup',
    templateUrl: './innitial-popup.component.html',
    styleUrls: ['./innitial-popup.component.scss'],
    standalone: false
})
export class InnitialPopupComponent implements OnDestroy {
  private readonly popupService = inject(PopupService);

  private readonly kindergartenService = inject(KindergartenService);

  private readonly router = inject(Router);

  private readonly links = inject(RouterLinkFactory);

  private readonly linksService = inject(LinksService);

  protected readonly authService = inject(AuthService);

  @Input() popupKey: DismissedPopupKeywords;

  dontShowAgain = false;

  protected readonly isManager$ = this.authService.loggedUser$.pipe(
    map((user) => {
      return user.teacher.isDirector() || user.teacher.isManager();
    })
  );

  close() {
    this.popupService.closePopup(this.popupKey);
  }

  navigate() {
    this.close();
    if (this.kindergartenService.loggedKindergarten.isSK() || this.kindergartenService.loggedKindergarten.isSchool()) {
      this.router.navigate(this.links.teacherList());
      return;
    }
    const managementLink = this.linksService.getManagementAppUrl({ redirect: '/settings/user/list' });
    window.open(managementLink.url, managementLink.target);
  }

  ngOnDestroy(): void {
    if (this.dontShowAgain) {
      this.popupService.dismissPopup(this.popupKey);
    }
    this.popupService.closePopup(this.popupKey, true);
  }
}
